export default "__VITE_ASSET__Bvtwxpdj__"